import React, {useState} from "react";
import {GraphQlDataGrid} from "../../../../components/common/grid/GraphQlDataGrid";
import {useNavigate} from "react-router-dom";
import {GridColDef, GridRenderCellParams} from "@mui/x-data-grid";
import {Breadcrumbs, Card, CardContent, CardHeader, IconButton, Link, Tooltip, Typography} from "@mui/material";
import DataObjectIcon from "@mui/icons-material/DataObject";
import {graphQLServices} from "../../../../services/GraphQLServices";
import {GenericModal} from "../generic-modal/GenericModal";
import {CodeBlock} from "../../../../components/common/CodeBlock";
import {GET_ALL_JOB_RUNS} from "../graphql/queries/gqlGetAllJobRuns";
import {JobRunStatus} from "./JobRunStatus";
import DensitySmallIcon from "@mui/icons-material/DensitySmall";
import moment from "moment";
import {graphql} from "cm6-graphql";
import {Status} from "./Status";

export const AllJobRuns: React.FC = (props) => {
	const [graphqlQuery, setGraphqlQuery] = useState("");
	
	const navigate = useNavigate();
	
	const columns: GridColDef[] = [
		{
			field: "details",
			headerName: "",
			width: 140,
			renderCell: (params: GridRenderCellParams) => {
				return (
					<>
						<IconButton
							aria-label="View GraphQl Query"
							onClick={() => setGraphqlQuery(params.row.graphQlQuery)}
						>
							<Tooltip title={"View GraphQl Query"}>
								<DataObjectIcon />
							</Tooltip>
						</IconButton>
						<IconButton aria-label="View Steps" onClick={() => navigate("/querytool/jobs/runs/steps?jobRunId=" + params.row.id)}>
							<Tooltip title={"View Steps"}>
								<DensitySmallIcon />
							</Tooltip>
						</IconButton>
					</>
				);
			},
		},
		{field: "id", headerName: "ID", width: 70},
		{ field: "job", headerName: "Job", width: 200,disableColumnMenu: true, sortable: false,
			renderCell: (params: GridRenderCellParams) => {
				return (
					<>
						{params.row.job.description}
					</>
				);
			},
		},
		
		{field: "start", headerName: "Start", width: 180,
			renderCell: (params: GridRenderCellParams) => {
				return (
					<>
						{params.row.start &&
							moment(params.row.start).format("DD-MM-YYYY HH:mm:ss")}
					</>
				);
			},},
		{field: "finish", headerName: "Finish", width: 180,
			renderCell: (params: GridRenderCellParams) => {
				return (
					<>
						{params.row.finish &&
							moment(params.row.finish).format("DD-MM-YYYY HH:mm:ss")}
					</>
				);
			},},
		{field: "description", headerName: "Description", width: 250},
		{field: "steps", headerName: "Steps", width: 500,disableColumnMenu: true, sortable: false,
			renderCell: (params: GridRenderCellParams) => {
				return (
					<>
						<JobRunStatus jobSteps={params.row.job.jobDefinition.jobSteps} jobRunSteps={params.row.jobStepRuns} />
					</>
				);
			},
		},
	];
	
	return (
		
		<div style={{height: "100%"}}>
			<Breadcrumbs aria-label="breadcrumb">
				<Link underline="hover" color="inherit" href="/querytool/jobdefinitions">
					QueryTool
				</Link>
				<Typography color="text.primary">Job Runs</Typography>
			</Breadcrumbs>
			<Status/>
			<Card variant={"outlined"}>
				<CardHeader title={"Runs"}/>
				<CardContent>
					<GraphQlDataGrid
						query={GET_ALL_JOB_RUNS}
						enableHeaderFilter
						graphFunction={"jobRun"}
						client={graphQLServices.querytoolClient}
						rowsPerPageOptions={[10, 20, 50]}
						initialPageSize={10}
						columns={columns}
						rows={[]}
						defaultSortModel={[
							{
								field: "id",
								sort: "desc",
							},
						]}
					/>
				</CardContent>
			</Card>
			
			<GenericModal open={!!graphqlQuery} onClose={() => setGraphqlQuery("")} title={"GraphQl Query"}>
				<CodeBlock name={"GraphQl Query"} syntax={graphql()}>
					{graphqlQuery}
				</CodeBlock>
			</GenericModal>
		</div>
	);
};
